<template>
  <div class="info-modal__content__title">
    <h4>{{ $t('modal_content.assumption_of_insurance_costs.title') }}</h4>
  </div>
  <div class="info-modal__content__text">
    {{ $t('modal_content.assumption_of_insurance_costs.text') }}
  </div>
</template>

<script setup lang="ts"></script>
